import __request__ from 'routing/request';
interface UrlAllowlist {
    readonly entries: AllowlistEntry[];
    readonly disabled: boolean;
}
interface AllowlistCheckResponse {
    readonly is_allowlisted: boolean;
    readonly url: string;
}
interface AllowlistCheckRequest {
    readonly url: string;
}
interface AllowlistEntry {
    readonly id: string;
    readonly type: 'literal' | 'regex';
    readonly title: string;
    readonly value: string;
}
interface AllowlistRegexGenerationResponse {
    readonly regex: string;
}
interface AllowlistRegexGenerationRequest {
    readonly url_template: string;
    readonly placeholder: string;
}
/**
 * Update url allowlist.
 */
export function put(allowlist: UrlAllowlist): Promise<unknown> {
    return __request__('PUT', '/system/urlallowlist', allowlist, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get url allowlist.
 */
export function get(): Promise<UrlAllowlist> {
    return __request__('GET', '/system/urlallowlist', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Check if a url is allowlisted.
 */
export function check(JSONbody: AllowlistCheckRequest): Promise<AllowlistCheckResponse> {
    return __request__('POST', '/system/urlallowlist/check', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Generates a regex that can be used as a value for a allowlist entry.
 */
export function generateRegex(JSONbody: AllowlistRegexGenerationRequest): Promise<AllowlistRegexGenerationResponse> {
    return __request__('POST', '/system/urlallowlist/generate_regex', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
